<template>
    <v-container fluid fill-height>
        <v-layout justify-center>
            <v-flex xs12>
                <v-card class="elevation-12">
                    <div class="toolbox-header">
                        <v-toolbar-title>An error occured while loading</v-toolbar-title>
                    </div>
                    <v-card-text>
                        {{ error }}
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  export default {
    props: {
      error: {
        required: true
      }
    }
  }
</script>
